import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import ContentPolicyPage from "./pages/ContentPolicyPage";
import DMCAPage from "./pages/DMCAPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/content-policy" element={<ContentPolicyPage />} />
          <Route path="/dmca" element={<DMCAPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
